import { FC, useMemo } from "react";
import { Page, Document as PdfDocument } from "react-pdf";
import * as Styled from "./PdfControls.styled";

type PdfViewerProps = {
    file: Uint8Array | null;
    startPage: number;
    endPage: number;
    scale?: number;
    onLoaded?: () => void;
};

export const PdfViewer: FC<PdfViewerProps> = ({ file, startPage, endPage, scale, onLoaded }) => {
    // Memoize file
    const docFile = useMemo(() => (file ? { data: file } : null), [file]);

    return (
        <PdfDocument
            file={docFile}
            loading={
                <Styled.CenteredStack>
                    <Styled.BigCircularProgress />
                </Styled.CenteredStack>
            }
            noData={
                <Styled.CenteredStack>
                    <Styled.BigCircularProgress />
                </Styled.CenteredStack>
            }
        >
            {Array.from({ length: endPage - startPage + 1 }, (_, index) => {
                return (
                    <Page
                        key={index}
                        scale={scale}
                        pageNumber={startPage + index}
                        renderTextLayer={false}
                        renderAnnotationLayer={false}
                        onRenderSuccess={() => onLoaded?.()}
                    />
                );
            })}
        </PdfDocument>
    );
};
